import { Icon$5, Icon$31, Icon$62, Icon$59, Icon$74, Icon$54, Icon$24, Icon$105, Icon$104, Icon$26, Icon$27, Icon$61, Icon$60, Icon$40, Icon$39, Icon$81, Icon$77, Icon$16, Icon$88, Icon$11, Icon$22, Icon$0, Icon$53, Icon$63, Icon$35, Icon$34, Icon$13, Icon$8, Icon$19, Icon$33, Icon$56 } from './vidstack-CRlI3Mh7.js';

const icons = {
  airplay: Icon$5,
  download: Icon$31,
  play: Icon$62,
  pause: Icon$59,
  replay: Icon$74,
  mute: Icon$54,
  "google-cast": Icon$24,
  "volume-low": Icon$105,
  "volume-high": Icon$104,
  "cc-on": Icon$26,
  "cc-off": Icon$27,
  "pip-enter": Icon$61,
  "pip-exit": Icon$60,
  "fs-enter": Icon$40,
  "fs-exit": Icon$39,
  "seek-forward": Icon$81,
  "seek-backward": Icon$77,
  "menu-chapters": Icon$16,
  "menu-settings": Icon$88,
  "menu-arrow-left": Icon$11,
  "menu-arrow-right": Icon$22,
  "menu-accessibility": Icon$0,
  "menu-audio": Icon$53,
  "menu-audio-boost-up": Icon$104,
  "menu-audio-boost-down": Icon$105,
  "menu-playback": Icon$63,
  "menu-speed-up": Icon$35,
  "menu-speed-down": Icon$34,
  "menu-captions": Icon$27,
  "menu-quality-up": Icon$13,
  "menu-quality-down": Icon$8,
  "menu-radio-check": Icon$19,
  "menu-font-size-up": Icon$13,
  "menu-font-size-down": Icon$8,
  "menu-opacity-up": Icon$33,
  "menu-opacity-down": Icon$56,
  "kb-play": Icon$62,
  "kb-pause": Icon$59,
  "kb-mute": Icon$54,
  "kb-volume-up": Icon$104,
  "kb-volume-down": Icon$105,
  "kb-fs-enter": Icon$40,
  "kb-fs-exit": Icon$39,
  "kb-pip-enter": Icon$61,
  "kb-pip-exit": Icon$60,
  "kb-cc-on": Icon$26,
  "kb-cc-off": Icon$27,
  "kb-seek-forward": Icon$35,
  "kb-seek-backward": Icon$34
};

export { icons };
